
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TestimonialsHero from './components/TestimonialsHero';
// import TestimonialsGrid from './components/TestimonialsGrid';
import StatsSection from './components/StatsSection';

const Testimonials = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <TestimonialsHero />
        <StatsSection />
        {/* <TestimonialsGrid /> */}
      </main>
      <Footer />
    </div>
  );
};

export default Testimonials;
